module.exports = __webpack_public_path__ + "static/helvetica-f0d7d673ef06ec9cf090dc00572d63e4.otf";